import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import LunchCalendar from '../components/LunchCalendar';
import { t } from '../i18n';

export default function AvailabilityPage() {
  const { user, refreshUser } = useAuth();
  const [availability, setAvailability] = useState([]);
  const [bookedMatches, setBookedMatches] = useState([]);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    if (user) {
      setAvailability(user.availability?.map(d => typeof d === 'string' ? d.split('T')[0] : d) || []);
    }
    api.get('/matches').then(r => {
      const bm = r.data.map(m => ({
        date: m.matched_date?.slice(0, 10),
        participants: m.participants || []
      })).filter(bm => bm.date);
      setBookedMatches(bm);
    }).catch(() => {});
  }, [user]);

  const save = async () => {
    await api.put('/profile/availability', { dates: availability });
    await refreshUser();
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div style={{ padding: '32px 0', minHeight: '80vh' }}>
      <div className="container">
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ fontSize: 28, marginBottom: 6 }}>{t('profileAvailability')}</h1>
          <p style={{ color: 'var(--text-muted)' }}>{t('profileAvailabilityInfo')}</p>
        </div>
        <div className="card" style={{ padding: 32, maxWidth: 560 }}>
          <LunchCalendar selected={availability} onChange={setAvailability} bookedMatches={bookedMatches} />
          <div style={{ marginTop: 24 }}>
            <button className="btn btn-primary" onClick={save} style={{ minWidth: 140 }}>
              {saved ? t('profileSaved') : t('profileSaveChanges')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
